/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useMappedCategoryData } from '../../../api/mapCategoryData';
import { usePageType } from '../../../api/getPageType';
import { MostPopularParts } from '../../MostPopularParts';
import { useAcesFlags } from '@/features/ymme/utils/acesFlags';
import { interpolateLabel } from '@/utils/labels/interpolateLabel';
import { useLabels } from '@/hooks/useLabels';

const labelMap = {
  lblMostPopularParts: 'label_most_popular_parts',
  lbMostPopularPartsWithMake: 'label_most_popular_parts_with_make',
};

export const CMSMostPopularParts = () => {
  const { data: categoryData } = useMappedCategoryData();
  const { data: pageTypeData } = usePageType();
  const { acesEnabled } = useAcesFlags();
  const { lblMostPopularParts, lbMostPopularPartsWithMake } = useLabels(labelMap);

  const heading = pageTypeData?.make
    ? interpolateLabel(lbMostPopularPartsWithMake, {
        make: pageTypeData?.make,
      })
    : lblMostPopularParts;

  const hasNoCategories = acesEnabled
    ? !categoryData?.popularCategories?.length
    : !categoryData?.shopByCategory?.length;

  if (hasNoCategories) {
    return null;
  }

  const mostPopularParts = acesEnabled
    ? categoryData?.popularCategories
    : categoryData?.mostPopularParts;

  return (
    <MostPopularParts
      data={{
        name: heading,
        topTwelvemostPopularPartTypes: mostPopularParts?.map((part) => ({
          ...part,
          properties: {
            ...(part.properties || {}),
            makeModelYearPath: pageTypeData?.makeModelYearPath,
            seoUrl: part.properties?.seoUrl || '',
            refPageType: part.properties?.refPageType || '',
            imageUrl: part.properties?.imageUrl || '',
          },
        })),
      }}
    />
  );
};
